import { Container, Grid, Heading } from '@asktia/tia-ui'
import { FC, Fragment } from 'react'
import { SuggestionItem } from '../SuggestionItem'
import { useAppointmentSuggestions } from 'src/hooks/useAppointmentSuggestions'
import { groupBy, uniq } from 'lodash'
import { AppointmentSuggestion, Intervention } from 'src/types'
import { SuggestionTitle } from './components/SuggestionTitle'
import { useCarePlan } from 'src/hooks/useCarePlan'
import { CarePlanItem } from 'src/pages/Home/ActionsToComplete/AppointmentFollowups/CarePlanItem'

export const AppointmentFollowUps: FC = () => {
    const { data: interventions, isLoading: isLoadingCarePlan } = useCarePlan()

    const {
        appointmentSuggestions,
        isLoading: isLoadingAppointmentSuggestions
    } = useAppointmentSuggestions({
        status: 'pending',
        actionDismissed: false
    })

    const partnershipCareItems = interventions?.filter(
        intervention =>
            intervention.partner && intervention.partner.type === 'integrated'
    )

    const appointmentIds =
        uniq([
            ...(appointmentSuggestions || []).map(
                x =>
                    x?.interventionFollowup?.carePlanIntervention
                        ?.originAppointment?.id
            ),
            ...((partnershipCareItems || [])?.map(
                intervention => intervention.originAppointment?.id
            ) || [])
        ]) || []

    const groupedSuggestionsByAppointment = groupBy(
        appointmentSuggestions,
        (x: AppointmentSuggestion) =>
            x?.interventionFollowup?.carePlanIntervention?.originAppointment?.id
    )

    const groupedCareItemsByAppointment = groupBy(
        partnershipCareItems || [],
        (intervention: Intervention) =>
            intervention?.originAppointment?.id || 'undefined' // Handle undefined appointments
    )

    const actionsToShow =
        !isLoadingAppointmentSuggestions &&
        !isLoadingCarePlan &&
        appointmentIds &&
        appointmentIds.length > 0

    // eslint-disable-next-line no-constant-condition
    return actionsToShow ? (
        <Container>
            <Heading h1 sx={{ pt: 6, mb: 6 }}>
                Next steps from your providers
            </Heading>
            {appointmentIds.map(id => {
                const suggestions =
                    groupedSuggestionsByAppointment[id || 'undefined'] || []

                const careItems =
                    groupedCareItemsByAppointment[id || 'undefined'] || []

                return (
                    <Fragment key={`${id}-suggestion`}>
                        <SuggestionTitle
                            suggestions={suggestions}
                            careItems={careItems}
                        />
                        <Grid
                            key={`${id}-suggestion`}
                            gap={4}
                            sx={{ alignItems: 'flex-start' }}
                            columns={['1fr', '1fr 1fr 1fr']}
                            pt="4"
                            mb={4}
                        >
                            {careItems.map(item => {
                                return (
                                    <CarePlanItem
                                        key={`${item.carePlanIntervention.uuid}`}
                                        {...item}
                                    />
                                )
                            })}

                            {suggestions.map(suggestion => {
                                return (
                                    <SuggestionItem
                                        key={`${suggestion.uuid}`}
                                        {...suggestion}
                                    />
                                )
                            })}
                        </Grid>
                    </Fragment>
                )
            })}
        </Container>
    ) : (
        <></>
    )
}
